var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "histogram", style: _vm.css_props, attrs: { id: "qpe_histogram" } },
    [_c("div", { style: { "text-align": "center" }, attrs: { id: _vm.id } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }